import React from 'react';
import { resolvePickupAdult } from '../lib/pickups';

// ─── PICKUP CARD ──────────────────────────────────────────────────────────────
// Compact assign strip for a school-pickup row, styled like EventCard's
// actions. Used both in the day's unset/skipped action strip and — for
// already-assigned pickups — inline inside the assignee's person column, so
// a pickup is re-assignable wherever it appears.

export default function PickupCard({ pickup, isPending, onAssign, carePartners = [], pickupCaregivers = [], sitters = [] }) {
  const adultName = resolvePickupAdult(pickup.adultId, { carePartners, sitters });
  const changed = pickup.source === 'override' || isPending;

  return (
    <div className={`pickup-card ${pickup.skipped ? 'pickup-card--skipped' : ''}`}>
      <div className="pickup-card__top">
        <span className="pickup-card__label">{pickup.leg === 'dropoff' ? '🎒' : '🚗'} {pickup.label} · {pickup.childName} · {pickup.time}</span>
        {!pickup.adultId && !pickup.skipped && <span className="badge badge--unassigned">unset</span>}
        {pickup.skipped && <span className="badge badge--gray">skipped today</span>}
        {changed && !pickup.skipped && <span className="badge badge--override">changed for this day</span>}
        {pickup.adultId && !changed && <span className="pickup-card__adult">{adultName}</span>}
      </div>
      <div className="pickup-card__actions">
        {carePartners.map(cp => (
          <button key={cp.identifier}
            className={`assignee-btn ${pickup.adultId === cp.identifier ? 'assignee-btn--active' : ''}`}
            onClick={() => onAssign(cp.identifier)}
            title={cp.name}
          >({cp.identifier})</button>
        ))}
        {pickupCaregivers.map(s => (
          <button key={s.id}
            className={`assignee-btn assignee-btn--family ${pickup.adultId === `cg:${s.id}` ? 'assignee-btn--active' : ''}`}
            onClick={() => onAssign(`cg:${s.id}`)}
            title={s.firstName}
          >({s.firstName?.[0]?.toUpperCase() || '?'})🌱</button>
        ))}
        {!pickup.skipped && (
          <button className="assignee-btn assignee-btn--cancel" onClick={() => onAssign('skip')} title="Skip pickup for this day">skip</button>
        )}
        {changed && (
          <button className="assignee-btn assignee-btn--add-sitter" onClick={() => onAssign(null)} title="Revert to the weekly default">↺ default</button>
        )}
      </div>
    </div>
  );
}
